export default __webpack_public_path__ + "static/support-sponsor-lbp-ad99a53ac27b0b18d1ceefafc828f236.png";